import { message } from 'antd';
import { useState } from 'react';
import { httpRequest } from '../helpers/api';
import {
  getErrorMessage,
  saveToken,
  BaseResponseProps,
} from '@qlibs/react-components';
import { useSignIn } from 'react-auth-kit';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../const/config';
import useMasterData from './useMasterData';
import { getCmsDeviceId } from '../helpers/auth';

type Props = {
  apiLoginUrl?: string;
  apiGetMyProfileUrl?: string;
};

export default function useAuthApp(props?: Props) {
  const navigate = useNavigate();
  const signIn = useSignIn();

  const { getListGroup } = useMasterData();

  const [isAuthLoading, setIsAuthLoading] = useState<boolean>(false);
  const [isShowCompany, setIsShowCompany] = useState<boolean>(false);

  const doLogin = async (
    data: {
      email: string;
      password: string;
      host: string;
      rememberMe?: boolean;
    },
    callback?: () => void
  ) => {
    setIsAuthLoading(true);
    try {
      const resultAuthLogin = await axios.post<
        BaseResponseProps<{
          access_token: string;
          refresh_token: string;
          accessTokenExpiresInMinutes?: number;
        }>
      >(
        props?.apiLoginUrl || process.env.REACT_APP_BASE_URL + '/auth/signin',
        {
          ...data,
          platform: 'cms',
          deviceId: getCmsDeviceId(),
          deviceName: navigator.userAgent.slice(0, 128) || 'CMS browser',
          appVersion: process.env.REACT_APP_VERSION || '',
        }
      );

      if (!resultAuthLogin) {
        setIsAuthLoading(false);
        message.error('Login failed. Empty response.');
        return;
      }

      if (resultAuthLogin) {
        saveToken(resultAuthLogin.data.payload.access_token);
      }

      const resProfile = await fetchUser(
        resultAuthLogin.data.payload.access_token
      );

      if (
        !resProfile?.data?.payload?.role?.permissions?.AUTH?.includes(
          'LOGIN_CMS_ADMIN'
        ) &&
        !resProfile?.data?.payload?.role?.permissions?.AUTH?.includes(
          'LOGIN_CMS'
        )
      ) {
        message.error('Your account does not have access rights to login');
        setIsAuthLoading(false);
        return;
      }

      setIsShowCompany(true);

      await setUserData(
        resultAuthLogin.data.payload.access_token,
        resProfile,
        resultAuthLogin.data.payload.accessTokenExpiresInMinutes,
        callback
      );
    } catch (err) {
      message.error('Login failed. ' + getErrorMessage(err));
    }

    setIsAuthLoading(false);
  };

  const signInUsingToken = async (access_token: string) => {
    try {
      const resProfile = await fetchUser(access_token);
      if (access_token && resProfile) {
        saveToken(access_token);
      }

      await setUserData(access_token, resProfile);
    } catch (error) {
      message.error('Auth failed');
    }
  };

  const fetchUser = async (access_token: string) => {
    const resProfile: any = await axios.get<
      BaseResponseProps<{
        token: string;
      }>
    >(
      props?.apiGetMyProfileUrl || process.env.REACT_APP_BASE_URL + '/users/me',
      {
        headers: {
          Authorization: 'Bearer ' + access_token,
        },
      }
    );

    if (!resProfile) {
      message.error('Login failed. No profile.');
      setIsAuthLoading(false);
      return;
    }

    return resProfile;
  };

  const setUserData = async (
    access_token: string,
    resProfile: any,
    expiresIn?: number,
    callback?: () => void
  ) => {
    if (
      signIn({
        token: access_token,
        expiresIn: expiresIn || 10000,
        tokenType: 'Bearer',
        authState: resProfile.data.payload,
        // authState: { token: resultAuthLogin.data.payload.token },
        // refreshToken: res.data.refreshToken, // Only if you are using refreshToken feature
        // refreshTokenExpireIn: res.data.refreshTokenExpireIn, // Only if you are using refreshToken feature
      })
    ) {
      // Redirect or do-something
      // console.log(resProfile)
      if (callback) {
        // callback();
      } else {
        // navigate(config.defaultPath || "/home", { replace: true });
      }
      // message.success("Welcome to " + process.env.REACT_APP_WEBSITE_NAME);
    } else {
      message.error('Login failed.');
      //Throw error
    }
  };

  return {
    isAuthLoading,
    doLogin,
    isShowCompany,
    signInUsingToken,
  };
}
